<template>
  <base-material-card
    class="px-5 py-3"
    color="bgTemperature"
    inline
    icon="mdi-coolant-temperature"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light text-start v-card--material__heading mb-n6 v-sheet theme--dark elevation-6 bgTemperature pa-8">
        {{ $t("tanks-set.current-status") }}
        <span class="subtitle-1">— {{ temperatureCurretStatus.targetDeviceDescription }}</span>
      </div>
    </template>
    <v-row>
      <v-col
        cols="12"
        md="5"
      >
        <h3 class="info--text">
          {{ $t('tanks-set.registerAt') }}:
        </h3>
      </v-col>
      <v-col
        cols="12"
        md="7"
      >
        <h3 class="font-weight-bold">
          {{ temperatureCurretStatus.registerAt | formatLongDate }}
        </h3>
      </v-col>
    </v-row>
    <v-row
      class="justify-center"
    >
      <v-col
        md="4"
        sm="2"
      >
        <vue-thermometer
          v-show="thermoValue > temperatureCurretStatus.max"
          :value="thermoValue"
          :scale="thermometerScale"
          :max="maxValue"
          :min="minValue"
          :options="optionsMax"
        />
        <vue-thermometer
          v-show="thermoValue < temperatureCurretStatus.min"
          :value="thermoValue"
          :scale="thermometerScale"
          :max="maxValue"
          :min="minValue"
          :options="optionsMin"
        />
        <vue-thermometer
          v-show="thermoValue >= temperatureCurretStatus.min && thermoValue <= temperatureCurretStatus.max"
          :value="thermoValue"
          :scale="thermometerScale"
          :max="maxValue"
          :min="minValue"
          :options="options"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        sm="4"
      >
        <v-row dense>
          <v-col
            cols="12"
            md="12"
          >
            <v-card class="ma-0">
              <v-card-title class="">
                {{ $t('temperature-set.temperature') }}
              </v-card-title>
              <v-card-text>
                <span class="subtitle-1"><span class="headline">{{ thermoValue }}{{ thermometerScale }}</span></span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-card class="ma-0">
              <v-card-title class="">
                {{ $t('temperature-set.min') }}
              </v-card-title>
              <v-card-text>
                <span class="subtitle-1"><span class="headline">{{ temperatureCurretStatus.min }}{{ thermometerScale }}</span></span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-card class="ma-0">
              <v-card-title class="">
                {{ $t('temperature-set.max') }}
              </v-card-title>
              <v-card-text>
                <span class="subtitle-1"><span class="headline"> {{ temperatureCurretStatus.max }}{{ thermometerScale }}</span> </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </base-material-card>
</template>

<script>
  import filters from '@/common/filters'
  import VueThermometer from 'vuejs-thermometer'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const temperaturesRespository = repositoryFactory.get('temperatures')

  export default {
    name: 'TemperatureStateView',
    components: { VueThermometer },
    mixins: [filters],
    props: {
      targetDeviceId: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        thermometerScale: '',
        thermoValue: 0,
        temperatureCurretStatus: {
          targetDevice: {},
        },
        showErrorMessage: false,
        errorMessage: '',
        polling: null,
        options: {
          thermo: {
            color: '#8BC34A',
          },
        },
        optionsMin: {
          thermo: {
            color: '#0000FF',
          },
        },
        optionsMax: {
          thermo: {
            color: '#FF0000',
          },
        },
        maxValue: 100,
        minValue: 0,
      }
    },
    mounted () {
      var self = this
      self.fetchData(self.targetDeviceId)
      self.polling = setInterval(function () { self.fetchData(self.targetDeviceId) }, 0.5 * 60 * 1000)
      self.$root.$on('updateTemperatureStateView', () => {
        self.fetchData(self.targetDeviceId)
      })
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      fetchData (targetDeviceId) {
        var self = this

        temperaturesRespository.getCurrent(targetDeviceId).then(response => {
          self.temperatureCurretStatus = response.data.data
          self.thermometerScale = self.temperatureCurretStatus.isFahrenheit ? '°F' : '°C'
          self.thermoValue = self.temperatureCurretStatus.isFahrenheit ? self.temperatureCurretStatus.fahrenheit : self.temperatureCurretStatus.celsius

          self.minValue = self.temperatureCurretStatus.min - 10
          if (self.thermoValue < self.minValue) {
            self.minValue = self.thermoValue - 2
          }

          self.maxValue = self.temperatureCurretStatus.max + 10
          if (self.thermoValue > self.maxValue) {
            self.maxValue = self.thermoValue + 2
          }
        }).catch(err => {
          self.showErrorMessage = true
          self.errorMessage = err
        })
        this.options.thermo.color = '#0000FF'
      },
    },
  }
</script>

<style>
.bgTemperature{
  background-color: #023A66 !important;
}
</style>
